<template>
  <!-- 正常状态的显示；代办状态的显示 -->
  <div class="order-status-form clearfix">
    <template v-if="showForm">
      <component :is="status" ref="orderStatusForm" :selectOrder="selectOrder" :status="status" :order="order" :orderStatus="orderStatus" @updateLoading="updateLoading" @on-error="onError" @on-success="onSuccess"></component>

      <el-button size="small" @click="next" type="primary" class="next btn">{{submitText}}</el-button>
    </template>

    <task-operate v-else @on-success="onSuccess" @before-submit="updateLoading" @on-error="onError" :orderDetail="order" :task="task"></task-operate>
    <!--
      1. 委托信息为不需要返还的，则只有【确认已完成交付】【延期交付】
      2. 委托信息为需要返还的，则需要先【确认已处置】、然后才能操作【确认已完成交付】
    -->
    <!-- 待交付状态下：确认已处置、确认已交付 -->
    <template v-if="status==='BILL_DELIVER'">
      <el-button size="small" v-if="order.back" :disabled="order.isHandle" @click="handle" type="primary" class="next btn">确认已处置</el-button>

      <el-button size="small" :disabled="order.back && !order.isHandle" @click="over" type="primary" class="next btn">确认已完成交付</el-button>
    </template>

    <!-- 延期交付 -->
    <el-button size="small" v-if="showDelay" @click="handleDialog('YAN_QI_JIAO_FU')" type="primary" :disabled="!HAS_PERM_DELAY"  class="next btn">延期交付</el-button>

    <handle-dialog v-if="status==='BILL_DELIVER' || showDelay" :dialogVisible="showDialog" :handleType="handleType" :billData="order" @reload="reload" @close="closeDialog">
    </handle-dialog>
  </div>
</template>
<script>
import taskOperate from './form/components/task-operate'
import handleDialog from './dialog/index.vue'
import BILL_CHECKED from './form/BILL_CHECKED'
import BILL_BACK from './form/BILL_BACK'
import BILL_RECEIVE from './form/BILL_RECEIVE'
import BILL_DELIVER from './form/BILL_DELIVER'
import {nextTrust} from './status'
import { hasPermissions } from 'utils/permissions'

export default {
  name: 'order-status',
  props: {
    status: {
      type: String,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      default: () => {}
    },
    orderStatus: [Array],
    selectOrder: [Array]
  },
  components: {
    taskOperate,
    handleDialog,
    BILL_CHECKED,
    BILL_BACK,
    BILL_RECEIVE,
    BILL_DELIVER
  },
  data () {
    return {
      title: '',
      creatNum: 0,
      isReviewOK: true,
      showDialog: false,
      handleType: ''
    }
  },
  computed: {
    HAS_PERM_DELAY () {
      const M_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_M')
      const SETTLEMENT_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_08')
      return M_PERM || SETTLEMENT_PERM
    },
    showForm () {
      const noForm = ['BILL_ASSIGN', 'BILL_EXECUTE', 'BILL_DELIVER']
      return !this.task && !noForm.includes(this.status)
    },
    showDelay () {
      const res = ['BILL_ASSIGN', 'BILL_EXECUTE', 'BILL_DELIVER']
      return res.includes(this.status)
    },
    submitText () {
      let res = '提交'
      switch (this.status) {
        case 'BILL_BACK':
          res = '确认已回传'
          break
      }
      return res
    }
  },
  methods: {
    next (data) {
      let formValidata = this.$refs.orderStatusForm.formValidata
      if (formValidata) {
        formValidata().then(response => {
          this.doNext(data)
        }).catch(err => {
          console.warn(err)
        })
      } else {
        this.doNext()
      }
    },
    doNext (data) {
      this.$emit('isLoading', true)
      this.$refs.orderStatusForm.next(data).then(response => {
        this.$emit('isLoading', false)
        if (response.data.isPolling) {
          this.$emit('polling-reload')
        } else {
          this.$emit('status-change')
        }
      }).catch(err => {
        this.$emit('isLoading', false)
        this.$message.error(err.message || err)
      })
    },
    updateLoading (val) {
      this.$emit('isLoading', true)
    },
    onSuccess (data = {},statusResult) {
      let { isDELETE } = data
      if (isDELETE) {
        history.go(-1)
        return
      }
      this.$emit('isLoading', false)
      this.$emit('status-change',statusResult)
    },
    onError () {
      this.$emit('isLoading', false)
    },
    reload () {
      this.$emit('status-change')
    },
    handleDialog (type) {
      this.showDialog = true
      this.handleType = type
    },
    closeDialog () {
      this.showDialog = false
    },
    handle(){
      let data = {
        billId: this.order.id,
        action: 'BILL_DELIVER',
        billStatusDetail:{
          action: 'BILL_DELIVER',
          billStatusResult:'BILL_HANDLE',
        }
      }
      this.$emit('isLoading', true)
      nextTrust.call(this,data).then(response => {
        if (response.data.isPolling) {
          this.$emit('polling-reload')
        } else {
          this.$emit('status-change')
        }
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(()=>{
        this.$emit('isLoading', false)
      })
    },
    over(){
     let data = {
        billId: this.order.id,
        action: 'BILL_DELIVER',
        billStatusDetail:{
          action: 'BILL_DELIVER',
          billStatusResult:'BILL_DELIVERY',
        }
      }
      this.$emit('isLoading', true)
      nextTrust.call(this,data).then(response => {
        if (response.data.isPolling) {
          this.$emit('polling-reload')
        } else {
          this.$emit('status-change')
        }
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(()=>{
        this.$emit('isLoading', false)
      })
    },
  },
  watch: {

  },
  created () {
  }
}
</script>
<style lang="less">
.order-status-form {
  padding: 40px 20px;
  .el-button.next {
    margin-top: 30px;
  }
  el-textarea,
  .el-textarea__inner,
  .el-input__inner {
    width: 500px;
    font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
  }
  .el-upload-list {
    max-width: 800px;
  }
}
</style>
<style module lang="less">
.table {
  margin-bottom: 20px;
  &__title {
    font-weight: bold;
    padding: 20px 0;
  }
}
.upload {
  margin-top: 20px;
}
</style>
